import {MutationTree} from "vuex";
import {HdsCollectionMap, StateType} from "@/store/modules/hds/index";
import {Mappings} from "@/store/Database";

interface LoadOptions {
  /** データ */
  data: any;

  /** マッピング */
  mapping: Mappings<HdsCollectionMap>;

  /** 変更を破棄する場合 true そうでない場合 false */
  flushChanges: boolean;

  /** 全てのマッピングにおいて変更記録しない場合 true そうでない場合 false */
  disableChangesApi: boolean;
}

const mutations: MutationTree<StateType> = {
  /**
   * 指定されたデータをローカルデーターベースにロードします
   *
   * @param state  StateType
   * @param data ロードするデータ
   * @param mapping マッピング
   * @param flushChanges 変更を破棄する場合 true そうでない場合 false
   * @param disableChangesApi 全てのマッピングにおいて変更記録しない場合 true そうでない場合 false
   */
  load(state, {data, mapping, flushChanges = true, disableChangesApi = false}: LoadOptions) {
    // マッピングをコンパイル
    let mappingComponents = state.db.compileMapping(mapping);

    // 変更記録の無効化
    if(disableChangesApi || flushChanges) {
      mappingComponents = mappingComponents.map(mc => mc.with({isDisableChangesApi: true}));
    }

    // データのロード
    state.db.load(data, mappingComponents);

    // 変更を破棄する
    if(flushChanges) {
      state.db.flushChanges();
    }
  }
};

export default mutations;
